import script from "./detailTopic.vue?vue&type=script&setup=true&lang=js"
export * from "./detailTopic.vue?vue&type=script&setup=true&lang=js"

import "./detailTopic.vue?vue&type=style&index=0&id=9884535e&scoped=true&lang=css"

import exportComponent from "E:\\project\\lms-frontend-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9884535e"]])

export default __exports__